import styled from 'styled-components/macro'

import { EmptyState } from '@loadsmart/loadsmart-ui'

import EmptyStateImg from 'core/ui/assets/illustration-departing-truck.svg'

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
`

export function ErrorState() {
  return (
    <Wrapper>
      <EmptyState
        illustration={EmptyStateImg}
        variant="page"
        description="Looks like the page you're looking for does not exist or is not available anymore."
      />
    </Wrapper>
  )
}
